import { Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { brand } from '@/theme/theme';

/** The bits of an organization the switcher needs; `OrganizationSummary` satisfies this. */
export interface OrgSwitcherOrg {
  public_id: string;
  name: string;
}

export interface OrgSwitcherProps {
  orgs: OrgSwitcherOrg[];
  current: OrgSwitcherOrg | null;
  onSelect: (publicId: string) => void;
  /** Staff always see the switcher, even with a single (or no) organization. */
  isStaff?: boolean;
}

/** Client-hero org picker: translucent pill trigger, menu of the user's organizations. */
export function OrgSwitcher({ orgs, current, onSelect, isStaff = false }: OrgSwitcherProps) {
  if (orgs.length <= 1 && !isStaff) return null;
  return (
    <Menu shadow="md" width={220} position="bottom-end">
      <Menu.Target>
        <UnstyledButton
          px={12}
          py={6}
          style={{
            borderRadius: 999,
            backgroundColor: 'rgba(255,255,255,0.08)',
            border: `1px solid ${brand.onDarkLine}`,
          }}
        >
          <Group gap={6} wrap="nowrap">
            <Text fz={14} fw={600} c={brand.onDark}>
              {current?.name ?? ''}
            </Text>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path d="M2.5 4.5L6 8l3.5-3.5" stroke={brand.onDarkMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {orgs.map((org) => (
          <Menu.Item key={org.public_id} onClick={() => onSelect(org.public_id)}>
            {org.name}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
